// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__1VJxu","title":"styles_title__23iLP","button":"styles_button__HvIrz"};